export interface ITemplate {
  id: number;
  categoryId: number;
  siteFormat: string;
  name: string;
  content: string;
  contentFormat: string;
  numSections: number;
}

export interface ISubject {
  id: number;
  categoryId: number;
  siteFormat: string;
  name: string;
  content: string;
  contentFormat: string;
  numSections: number;
}

export interface IStructuredError {
  line: number;
  error: string;
  rid: number;
}

export interface IState {
  submittingChanges: boolean;
  loadingTemplates: boolean;
  loadingSubjects: boolean;
  loadingAlignmentResults: boolean;
  templates: ITemplate[];
  subjects: ISubject[];
  alignmentResults: IAlignmentResult;
  authenticatingUser: boolean;
  user: IUser | null;
  snackBarState: ISnackBarState | null;
  updateIds: string[];
  config: IConfig;
  loadingConfig: boolean;
}

// user details kept in JWT Id token in cookie
export interface IUser {
  valid: boolean;
}

export interface IAlignmentResultModule {
  uid: string;
  id: number;
  name: string;
  type: string;
  instance: number;
  visible: boolean;
  userVisible: boolean;
  content: any[];
  contextId: number;
  indent: number;
  sectionId: number;
  sectionUid: string;
  originalSectionName?: string;
  originalSectionId?: number;
  originalSectionUid?: string;
  readOnly: boolean;
  iconUrl: string;
  siteId: string;
}

export interface IAlignmentResultSection {
  uid: string;
  id: number;
  visible: boolean;
  name: SectionGroup;
  userVisible: boolean;
  section: number;
  content: any;
  contentFormat: string;
  siteId: string;
  modules?: IAlignmentResultModule[];
}

export interface IAlignmentResultGroup {
  name: string;
  sections?: IAlignmentResultSection[];
  modules?: IAlignmentResultModule[];
}

export interface IAlignmentResult {
  groups: IAlignmentResultGroup[];
  plans: any[];
  rules: any[];
}

export interface IDraggableAlignmentResultSection {
  uid: string;
  clonedUid?: string;
  id: number;
  name: string;
  visible: boolean;
  userVisible: boolean;
  section: number;
  content: any;
  contentFormat: string;
  resourceIds: string[];
}

export interface ISectionGroup {
  name: SectionGroup;
  sections: IDraggableAlignmentResultSection[];
}

export interface IDraggableAlignmentResult {
  sectionGroups: ISectionGroup[];
  resources: IResource[];
}

export interface IResource {
  uid: string;
  id: number;
  type: ResourceType;
  description: string;
  content: string;
  confidence: ConfidenceType;
  visible: boolean;
  userVisible: boolean;
  instance: number;
  contextId: number;
  indent: number;
  sectionId: number;
  sectionUid: string;
  originalSectionName?: string;
  originalSectionId?: number;
  originalSectionUid?: string;
  readOnly: boolean;
  iconUrl: string;
  siteId: string;
}

export enum ConfidenceType {
  HIGH = "high",
  MEDIUM = "medium",
  LOW = "low",
}

export enum ResourceType {
  IMAGE = "image",
  FILE = "file",
  URL = "url",
  FOLDER = "folder",
  VIDEO = "video",
  LABEL = "label",
  PAGE = "page",
  FORUM = "forum",
  ASSIGNMENT = "assign",
  QUIZ = "quiz",
  FEEDBACK = "feedback",
  RESOURCE = "resource",
  SURVEY = "survey",
  BOOK = "book",
  LTI = "lti",
}

export enum SectionGroup {
  SORTED = "sorted",
  UNSORTED = "unsorted",
  EXCLUDED = "excluded",
  DELETED = "deleted",
}

export interface ISnackBarState {
  type: "error" | "success";
  message: string;
  autoHideDuration: number;
}

export interface ICreateSubject {
  siteId: number;
  templateId: number;
  name: string;
  groups: IAlignmentResultGroup[];
}

export interface IUpdateSubject {
  siteId: number;
  templateId: number;
  groups: IAlignmentResultGroup[];
}

export enum ModalDialog {
  NONE = "none",
  RESULTS = "results",
  CANCEL = "cancel",
  SUBMIT = "submit",
  ERRORS = "errors",
  UPLOAD = "upload",
  REFRESH = "refresh",
}

export enum SiteUpdateStatus {
  SUCCESS = "ok",
  ERROR = "failed",
  IN_PROGRESS = "inprogress",
}

export interface IConfigVersion {
  version: number;
  timestamp: string;
  userToken: string;
}

export interface IConfig {
  templateIds: string[];
  adminIds: string[];
  versions?: IConfigVersion[];
  currentVersion: number;
  templateSections?: string[];
}

export interface IUploadRuleData {
  userToken: string;
  format: string;
  version: number;
  reportOnly: boolean;
}
